import * as React from 'react';
import styles from './index.less';
import MechaMainStore from '@src/pages/mecha/sections/main/store';
import wrapStore from '@src/utils/wrap-store';
import cx from 'classnames';
import Link from '@src/components/link';
const MechaMain = ({ store }) => {
  store.use();
  // const tag = store?.mechaStore?.currentMechaMsg?.mecha_type?.split('丨');
  return (
    <div className={cx(styles.mechaMainRoot, store.isActive && styles.mechaMainRootAct)}>
      <div className="new-mecha-group-8" data-name="头部">
        {/* <div className="new-mecha-layer-big-image-panel"> */}
        <div
          className={cx('new-mecha-layer-big-image', store?.mechaCurrentType === 1 && !store?.mechaTypeChangeState && styles.mecha_active)}
          style={{ backgroundImage: `url(${store?.mechaStore?.currentMechaMsg?.mecha_detail_image})` }}
        />
        {/* <div
            className={cx('new-mecha-layer-big-mask', store.mechaCurrentType === 1 && !store.mechaTypeChangeState && styles.mask_active)}
            style={{ backgroundImage: `url(${store.mechaStore?.currentMechaMsg?.main.mecha_main_mark})` }}
          /> */}
        {/* </div> */}

        <div className="new-mecha-group-9" data-name="左">
          <div className="new-mecha-group-11" data-name="信息框顶线">
            <div className="new-mecha-layer-23" data-order="dom-1" />
          </div>

          <div className="new-mecha-group-12" data-name="机甲名字">
            <Link
              className="new-mecha-back-list-btn"
              data-order="dom-6"
              onClick={() => store?.mechaStore?.onClickBackHome(store.mechaStore?.currentMechaMsg?.mecha_number)}
            />
          </div>
          <div className="new-mecha-group-13" data-name="机体名称">
            {/* 两个字的机甲 */}
            {store.mechaStore?.currentMechaMsg?.mecha_name?.length < 3 && (
              <div className="mecha-name-box mecha-name-box-len2">
                <div className="new-mecha-layer-cn-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_name}
                </div>
                <div className="new-mecha-layer-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_number}
                </div>
                <div className="new-mecha-layer-peculiarity" data-order="dom-5">
                  {/* 制空作战<br />战术变形 */}
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_1} </span>
                  <br />
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_2}</span>
                </div>
              </div>
            )}

            {/* 三个字的机甲 */}
            {store.mechaStore?.currentMechaMsg?.mecha_name?.length === 3 && (
              <div className="mecha-name-box mecha-name-box-len3">
                <div className="new-mecha-layer-cn-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_name}
                </div>
                <div className="new-mecha-layer-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_number}
                </div>
                <div className="new-mecha-layer-peculiarity" data-order="dom-5">
                  {/* 制空作战<br />战术变形 */}
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_1} </span>
                  <br />
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_2}</span>
                </div>
              </div>
            )}

            {/* 四个字的机甲 */}
            {store.mechaStore?.currentMechaMsg?.mecha_name?.length > 3 && (
              <div className="mecha-name-box mecha-name-box-len4">
                <div className="new-mecha-layer-cn-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_name}
                </div>
                <div className="new-mecha-layer-name" data-order="dom-5">
                  {store.mechaStore?.currentMechaMsg?.mecha_number}
                </div>
                <div className="new-mecha-layer-peculiarity" data-order="dom-5">
                  {/* 制空作战<br />战术变形 */}
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_1} </span>
                  <br />
                  <span>{store?.mechaStore?.currentMechaMsg?.mecha_tag_2}</span>
                </div>
              </div>
            )}

            <div className="name-line-1" />
            <div className="name-line-2" />
            <div className="name-line-3" />
          </div>
          <div className="new-mecha-info-btn">
            <Link data-btn-hover data-order="dom-6" onClick={() => store?.mechaStore?.handleOpen()} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default wrapStore(MechaMain, MechaMainStore);
